/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';

const StickyHeader = React.lazy(() => import('./StickyHeader'));

export const StickyHeaderSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  return (
    <Suspense fallback={<div />}>
      <StickyHeader {...props} />
    </Suspense>
  );
};
